import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./style.scss";

interface GeneralTabProps {
    defaultActiveKey?: string;
    onChange: (key: string) => void;
    tabs?: {
        eventKey: string;
        title: string;
        tabClassName?: string;
    }[];
    type?: "MEAL" | "GOODS" | "FOODS" | "DASHBOARD";
    disableTabs?: boolean;
    customClassNav?: string;
}

//TODO: remove from here
const mealTabs = [
    {
        eventKey: "1",
        title: "ناهار",
        tabClassName: "right",
    },
    {
        eventKey: "2",
        title: "شام",
        tabClassName: "left",
    },
];

const goodsTabs = [
    {
        eventKey: "1",
        title: "ماده اولیه",
        tabClassName: "right",
    },
    {
        eventKey: "2",
        title: "بار خشک",
        tabClassName: "left",
    },
];

const foodTypeTabs = [
    {
        eventKey: "1",
        title: "غذای سرگروه",
        tabClassName: "right",
    },
    {
        eventKey: "2",
        title: "غذای زیر مجموعه",
        tabClassName: "left",
    },
];

const dashboard = [
    {
        eventKey: "1",
        title: "اسنپ‌فود",
        tabClassName: "right",
    },
    {
        eventKey: "2",
        title: "اسنپ‌فود سازمانی",
        tabClassName: "left",
    },
];

const GeneralTab: React.FC<GeneralTabProps> = ({
    onChange,
    tabs,
    type,
    defaultActiveKey,
    disableTabs,
    customClassNav,
}) => {
    const renderTabs = () => {
        switch (type) {
            case "MEAL":
                return mealTabs;
            case "GOODS":
                return goodsTabs;
            case "FOODS":
                return foodTypeTabs;
            case "DASHBOARD":
                return dashboard;
            default:
                return tabs;
        }
    };
    return (
        <div className="tabsContainer mb-5">
            <Tabs
                onSelect={(value) => {
                    onChange(value as string);
                }}
                defaultActiveKey="1"
                activeKey={defaultActiveKey}
                className={customClassNav}
            >
                {renderTabs()!.map((tab) => (
                    <Tab
                        key={tab.eventKey}
                        tabClassName={`tabsContainer ${tab.tabClassName}`}
                        eventKey={tab.eventKey}
                        title={tab.title}
                        disabled={disableTabs}
                    />
                ))}
            </Tabs>
        </div>
    );
};

export default GeneralTab;
